import orderToPaymentType from '~~/helpers/Checkout/orderToPaymentType';
import { MAKE_PAYMENT_RESPONSE } from '~~/constants/paymentCustomFields';
import CustomPayment from '~~/constants/customPayment';
import { useUserOrder } from '~/utils/ct';
import type { ComposableFunctionArgs, Order, OrderQueryResult, OrderSearchParams, RawCustomField } from '~~/types/commercetools';

export const useUserOrderExtended = () => {

  const {
    loading,
    search: oldSearch,
    error,
    orders,
  } = useUserOrder();

  const isLoaded = ref(false);

  const order: ComputedRef<Order> = computed(() => orders.value?.results?.[0]);

  const orderNumber: ComputedRef<Order['orderNumber']> = computed(() => order.value?.orderNumber);

  const orderPayment: ComputedRef<RawCustomField | null> = computed(() =>
    order.value?.paymentInfo?.payments[0]?.custom?.customFieldsRaw
      ?.find(el => el.name === MAKE_PAYMENT_RESPONSE) ?? null,
  );

  const paymentType = computed(() => orderToPaymentType(order.value));

  const isOrderPaymentTypeBank = computed(() =>
    paymentType.value === CustomPayment.BANK_TRANSFER,
  );

  const isOrderPaymentTypeCod = computed(() =>
    paymentType.value === CustomPayment.COD,
  );

  const isOrderPaymentTypeAdyen = computed(() =>
    paymentType.value === CustomPayment.ADYEN);

  const search: typeof oldSearch = async (params: ComposableFunctionArgs<OrderSearchParams>) => {

    await oldSearch(params);
    isLoaded.value = true;
  
  };

  return {
    orders: orders as Ref<OrderQueryResult>,
    order,
    orderNumber,
    orderPayment,
    search,
    loading,
    isLoaded: computed(() => (isLoaded.value || !!order.value)),
    error,
    isOrderPaymentTypeBank,
    isOrderPaymentTypeCod,
    isOrderPaymentTypeAdyen,
    paymentType,
  };

};
